import { useBrandContext } from 'context/BrandProvider';
import techexpressLogo from 'assets/images/techexpress_large.svg';
import accessexpressLogo from 'assets/images/accessexpress_large.svg';
import nocexpressLogo from 'assets/images/nocexpress_large.svg';

import techexpressLogoLight from 'assets/images/light/techexpress.svg';
import accessexpressLogoLight from 'assets/images/light/accessexpress.svg';
import nocexpressLogoLight from 'assets/images/light/nocexpress.svg';

export const usePillarLogoByMode = () => {
  const { brand } = useBrandContext();

  if (brand?.mode === 'light')
    return {
      techexpressLogo: techexpressLogoLight,
      accessexpressLogo: accessexpressLogoLight,
      nocexpressLogo: nocexpressLogoLight,
    };

  return {
    techexpressLogo,
    accessexpressLogo,
    nocexpressLogo,
  };
};
